import { render } from "./NftViewer.vue?vue&type=template&id=291bd060&ts=true"
import script from "./NftViewer.vue?vue&type=script&lang=ts"
export * from "./NftViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__